import {CheckCircle2} from 'lucide-react'

function WhyExcel() {
  const reasons = [
    "Notion — это игрушка. Ты будешь полдня настраивать шрифты. Наш планер уже готов.",
    "Excel — это база. Есть на каждом ПК. Работает без интернета.",
    "Нам плевать на красоту. Нам важна результативность.",
  ]

  return (
    <section className="py-16 sm:py-24 px-4 sm:px-6 lg:px-8 bg-white fade-on-scroll opacity-0">
      <div className="max-w-4xl mx-auto">
        <h2 className="text-3xl sm:text-4xl lg:text-5xl font-black text-center text-black mb-12 sm:mb-16 uppercase">
          ПОЧЕМУ EXCEL, А НЕ NOTION/TRELLO? ОТВЕЧАЮ.
        </h2>

        <div className="space-y-6">
          {reasons.map((reason, index) => (
            <div
              key={index}
              className="flex items-start gap-4 sm:gap-6 bg-gray-50 p-6 sm:p-8 rounded-lg border-l-4 border-[#1E2B3C]"
            >
              <CheckCircle2 className="w-8 h-8 sm:w-10 sm:h-10 text-[#F45B3C] flex-shrink-0 mt-1" strokeWidth={2.5} />
              <p className="text-lg sm:text-xl text-gray-800 font-medium leading-relaxed">
                {reason}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}

export default WhyExcel
